import React, { FC } from "react";
import styled from "styled-components";
import Link from "next/link";
import dayjs from "dayjs";
import getUndef from "../../lib/get-undef";

interface Props {
  data?: any;
}

const Sale: FC<Props> = ({ data }) => {
  return (
    <>
      {data.map((item) => {
        const image = getUndef(
          () =>
            item.metafields.find(({ value }) => value === "big").files[0].url
        );
        const time = getUndef(
          () => item.metafields.find(({ key }) => key === "time").value
        );
        const formattedTime = time
          ? `До ${dayjs(time).format("D MMMM")}`
          : null;
        const description = getUndef(
          () =>
            item.metafields.find(({ key }) => key === "previewDescription")
              .value
        );
        const link = getUndef(
          () => item.metafields.find(({ key }) => key === "link")?.value
        );

        return (
          <SaleBlock key={item.id}>
            {image &&
              (link ? (
                <a href={link} target="_blank" rel="noopener noreferrer">
                  <WrraperImage>
                    <Image
                      className="contain"
                      width={675}
                      height={245}
                      src={image}
                      alt="акция"
                    />
                  </WrraperImage>
                </a>
              ) : (
                <Link href="/promo/[code]" as={`/promo/${item.slug}`}>
                  <WrraperImage>
                    <Image
                      className="contain"
                      width={675}
                      height={245}
                      src={image}
                      alt="акция"
                    />
                  </WrraperImage>
                </Link>
              ))}
            <Info>
              <div>
                {item.tags.map((tag, index) => (
                  <Tag key={index}>{tag}</Tag>
                ))}
              </div>
              {formattedTime && <EndSale>{formattedTime}</EndSale>}
              <Description>
                {link ? (
                  <a href={link} target="_blank" rel="noopener noreferrer">
                    <h4>{item.name}</h4>
                  </a>
                ) : (
                  <Link href="/promo/[code]" as={`/promo/${item.slug}`}>
                    <h4>{item.name}</h4>
                  </Link>
                )}

                <p>{description}</p>
              </Description>
            </Info>
          </SaleBlock>
        );
      })}
    </>
  );
};

const Description = styled.section`
  display: flex;
  flex-direction: column;
  line-height: 22px;

  h4 {
    line-height: 1.4;
    cursor: pointer;
  }

  p {
    margin: 0;
  }
`;

const Info = styled.div`
  margin-left: 30px;
  max-width: calc(50% - 30px);

  @media (max-width: 1000px) {
    margin: 0;
    max-width: 100%;
  }
`;
const WrraperImage = styled.div`
  max-width: 50%;
  border-radius: 10px;
  overflow: hidden;

  @media (max-width: 1000px) {
    margin-bottom: 20px;
    max-width: 660px;
  }

  @media (max-width: 715px) {
    margin-bottom: 20px;
    width: 100%;
  }

  @media (max-width: 630px) {
    margin-top: 20px;
  }
`;

const SaleBlock = styled.figure`
  display: flex;
  align-items: flex-start;
  margin: 0 0 50px;

  & > a {
    max-width: 50%;
  }

  a ${WrraperImage} {
    max-width: none;

    @media (max-width: 1000px) {
      margin-bottom: 20px;
      max-width: 660px;
    }
  }

  @media (max-width: 1000px) {
    display: block;
    margin-bottom: 40px;
    /* margin-bottom: 20px; */
  }
`;

const Image = styled.img`
  display: block;
  width: 100%;
  cursor: pointer;
`;

const Tag = styled.span`
  color: #e61917;
  font-weight: bold;
  font-size: 14px;
  margin-right: 15px;
`;

const EndSale = styled.time`
  font-size: 14px;
  color: #7b7a77;
`;

export default Sale;
